import { useContext, useMemo } from 'react';
import EntityDefinitionsContext from 'contexts/EntityDefinitionsContext';
import useTabs from 'screens/EntityDetailsShow/SelectedEntityProvider/useTabs';

const useEntityAppAndTabs = (
  entityNavItem: V3.Navigation.EntityApp | V3.Navigation.MappedEntityView,
) => {
  const { entityDetailsApps } = useContext(EntityDefinitionsContext);
  const entityApp = useMemo(() => {
    return entityDetailsApps.find((a) => a.id === entityNavItem.entityAppId);
  }, [entityDetailsApps, entityNavItem.entityAppId]);
  const { tabs } = useTabs({ app: entityApp });

  return {
    entityApp,
    tabs,
  };
};

export default useEntityAppAndTabs;
